export default __webpack_public_path__ + "media/zurb/img/events/rsvp/event-rsvp-person-icon-3b2327e4f38828ed2ad9f7b64f068da2.svg";